export default __webpack_public_path__ + "static/pakistanHeader-88301d01407eb85af420e4a53643b5a5.jpg";